import validate from "/home/tom/projects/ongehoord-ui-content/node_modules/.pnpm/nuxt@3.17.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_better-sqlit_ac6333106c0813e2703644621bc5c54b/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/tom/projects/ongehoord-ui-content/node_modules/.pnpm/nuxt@3.17.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_better-sqlit_ac6333106c0813e2703644621bc5c54b/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}